import React from 'react';

const Heading = ({
  children,
  level = 1,
  size,
  className = '',
  ...props
}) => {
  const Tag = `h${level}`;

  // デフォルトサイズをレベルに基づいて設定
  const defaultSizes = {
    1: 'text-4xl md:text-6xl',
    2: 'text-3xl md:text-4xl lg:text-5xl',
    3: 'text-2xl md:text-3xl',
    4: 'text-xl md:text-2xl',
    5: 'text-lg md:text-xl',
    6: 'text-base md:text-lg'
  };

  const headingSize = size || defaultSizes[level];
  const baseStyles = 'font-bold text-gray-800';

  return (
    <Tag className={`${baseStyles} ${headingSize} ${className}`} {...props}>
      {children}
    </Tag>
  );
};

export default Heading;
